.container {
  display: grid;
  gap: 5px;
}
